import { render } from "./Applyreopen.vue?vue&type=template&id=4ac6f940"
import script from "./Applyreopen.vue?vue&type=script&lang=js"
export * from "./Applyreopen.vue?vue&type=script&lang=js"

import "./Applyreopen.vue?vue&type=style&index=0&id=4ac6f940&lang=less"
script.render = render

export default script